export const CTD_PROC_ERROR_ROW = "CTD_PROC_ERROR_ROW";
export const CTD_PROC_FORM_DATA_FETCH_ERROR = "CTD_PROC_FORM_DATA_FETCH_ERROR";

export const CTD_PROC_DATA_FETCH_REQUEST = "CTD_PROC_DATA_FETCH_REQUEST";
export const CTD_PROC_DATA_FETCH_SUCCESS = "CTD_PROC_DATA_FETCH_SUCCESS";
export const CTD_PROC_DATA_FETCH_ERROR = "CTD_PROC_DATA_FETCH_ERROR";

export const CTD_PROC_SEARCH_FILTER = "CTD_PROC_SEARCH_FILTER";
export const CTD_PROC_RANGE_FILTER = "CTD_PROC_RANGE_FILTER";
export const CTD_PROC_STAGE_FILTER = "CTD_PROC_STAGE_FILTER";
export const CTD_PROC_SHOW_WIREWALKER = "CTD_PROC_SHOW_WIREWALKER";

export const CTD_PROC_DETAILS_MODAL_OPEN = "CTD_PROC_DETAILS_MODAL_OPEN";
export const CTD_PROC_DETAILS_MODAL_CLOSE = "CTD_PROC_DETAILS_MODAL_CLOSE";
export const CTD_PROC_DETAILS_MODAL_SET_DATA =
  "CTD_PROC_DETAILS_MODAL_SET_DATA";

export const CTD_PROC_SET_FORM_DATA_SEARCH_TEXT =
  "CTD_PROC_SET_FORM_DATA_SEARCH_TEXT";

export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
